export default {
  show(type, text) {
    const x = document.getElementById("snackbar");
    x.className = "show " + type;
    x.innerHTML = text;
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 3000);
  },
};



// WEBPACK FOOTER //
// ./src/helpers/toast.js